const p = "swiper", r = "teaser", t = "swiper__controls", e = {
  swiper: p,
  "swiper--top-padding": "swiper--top-padding",
  "swiper--bottom-padding": "swiper--bottom-padding",
  "swiper-wrapper": "swiper-wrapper",
  "swiper-slide": "swiper-slide",
  "teaser-card": "teaser-card",
  teaser: r,
  "swiper-pagination": "swiper-pagination",
  "swiper-pagination-current": "swiper-pagination-current",
  "swiper-pagination-total": "swiper-pagination-total",
  "swiper-pagination-fraction": "swiper-pagination-fraction",
  "swiper__button-next-custom": "swiper__button-next-custom",
  "swiper__button-prev-custom": "swiper__button-prev-custom",
  "swiper__button-autoplay-custom": "swiper__button-autoplay-custom",
  "swiper__button-icon-custom": "swiper__button-icon-custom",
  "swiper__button--disabled": "swiper__button--disabled",
  "swiper__autoplay-track": "swiper__autoplay-track",
  "swiper__autoplay-elapsed": "swiper__autoplay-elapsed",
  "swiper__autoplay-progress": "swiper__autoplay-progress",
  swiper__controls: t,
  "swiper__controls-wrapper": "swiper__controls-wrapper",
  "swiper__controls-wrapper--navigation-hidden": "swiper__controls-wrapper--navigation-hidden"
};
export {
  e as default,
  p as swiper,
  t as swiper__controls,
  r as teaser
};
